export default {
  // 文件库
  library: {
    field1: '机构文件',
    field2: '应用文件',
    field3: '个人文件',
    field6: '项目文件',
    field4: '我共享的',
    field5: '共享给我的',
    addFolder: '新建文件夹',
    seachFile: '搜索文件',
    filename: '文件名称',
    updatetime: '最后更新时间',
    updateperson: '更新人',
    sharedperson: '共享人',
    managefolders: '管理文件夹',
    setpermission: '设置权限',
    movefolder: '移动文件夹',
    sharedfile: '共享文件',
    sharedfolder: '共享文件夹',
    delfile: '删除文件',
    delfolder: '删除文件夹',
    cancelsharing: '取消共享',
    exitsharing: '退出共享',
    foldername: '文件夹名称',
    foldertype: '文件夹类型',
    publicTip: '公开（机构所有成员可见此文件夹）',
    privateTip: '私有（只有加入成员可见此文件夹）',
    selectcolor: '选择颜色',
    deltip: '删除后此文件夹中的文件和子文件夹将会一并删除且不可恢复。',
    moveto: '移动到...',
    selectfolder: '选择文件夹',
    folderdirectory: '文件夹目录',
    canceltip: '取消共享后所有共享成员将不可见该文件夹或文件。',
    canceldefine: '你确定要取消共享吗？',
    exitsharingtip: '退出共享后将不可见该文件夹或文件。',
    exittip: '你确定要退出吗？',
    member_empty: '成员不能为空',
    selectdirectory: '请选择目录',
    noauthority: '您没有操作该文件夹的权限',
    manage_empty: '管理员不能为空',
    err01: '只能按照模块搜索数据',
    err02: '只能项目分组搜索数据',
    childmanage: '子管理员',
    name_empty: '文件夹名称不能为空',
    name_length: '文件夹名称不能超过12个字符',
    cancel_empty: '共享成员不能为空',
    filedetails: '文件详情',
    publiclinks: '公开链接',
    uploadversion: '上传新版本',
    fileransfer: '转为机构文件',
    move: '移动',
    copy: '复制',
    share: '共享',
    sendchat: '发送到聊天',
    magnif: '放大',
    shrink: '缩小',
    rotate: '左旋转',
    rotate1: '右旋转',
    full: '全屏查看',
    downlint: '下载记录',
    hisedition: '历史版本',
    downperson: '下载人',
    downnum: '下载次数',
    downtime: '最近下载时间',
    currentversion: '当前版本',
    first: '第',
    edition: '版',
    linksharing: '链接共享',
    mailsharing: '邮箱共享',
    codesharing: '二维码共享',
    link: '链接地址',
    copyaddress: '复制地址',
    accesspwd: '访问密码',
    accessvalidity: '访问有效期',
    emailaddress: '邮箱地址',
    sharinghistory: '共享历史',
    scanningtip: '扫描上面的二维码完成分享',
    copyto: '复制到...',
    delfiletip: '删除文件后历史版本也会被一并删除，且不可恢复。',
    initiatechat: '发起聊天',
    privatechat: '发起私聊',
    lookgroup: '查看群组',
    sendtip: '发送成功',
    second: '次',
    pwd_error: '密码只能由4个数字组合',
    email_empty: '邮箱不能为空',
    email_error: '邮箱格式不正确',
    copytoclipboard: '已复制至剪切板',
    sharenote: '给您分享了文件',
    extractpwd: '请输入提取密码',
    extractfile: '提取文件',
    downfile: '下载文件',
    share2: '的分享',
    libraryMnage: '文件库管理',
    libraryNote: '管理机构内部资料，随时参与团队成员分享',
    fileset: '文件设置',
    disablefile: '禁用个人文件',
    enablefile: '启用个人文件',
    companymanag: '机构文件管理员',
    rootdirectory: '根目录列表',
    companydirectory: '机构文件的根目录。',
    publicity: '公开性',
    private: '私密',
    public: '公开',
    founder: '创建人',
    setmanage: '设置管理员',
    deltip2: '系统删除的文件都存储在这里，如果继续删除将从数据库中进行删除，无法再恢复文件。',
    deltip3: '删除文件将从数据库进行删除，删除后文件将无法恢复，确定要硬删除该文件吗？',
    deltime: '删除时间',
    delpeople: '删除人'
  }
}
